import AccordionBlock from '~/components/blocks/AccordionBlock.vue';
import ArticleListing from '~/components/blocks/ArticleListing.vue';
import ArticleProducts from '~/components/blocks/ArticleProducts.vue';
import CategoryListing from '~/components/blocks/CategoryListing.vue';
import ComplaintForm from '~/components/blocks/ComplaintForm.vue';
import ContactForm from '~/components/blocks/ContactForm.vue';
import CoverBlock from '~/components/blocks/CoverBlock.vue';
import DynamicPromoGrid from '~/components/blocks/DynamicPromoGrid.vue';
import EditorialProduct from '~/components/blocks/EditorialProduct.vue';
import ImageGallery from '~/components/blocks/ImageGallery.vue';
import NumberList from '~/components/blocks/NumberList.vue';
import ProductListingBlock from '~/components/blocks/ProductListingBlock.vue';
import PromoGrid from '~/components/blocks/PromoGrid.vue';
import QuoteBlock from '~/components/blocks/QuoteBlock.vue';
import StatisticsBlock from '~/components/blocks/StatisticsBlock.vue';
import TextImageVideoBlock from '~/components/blocks/TextImageVideoBlock.vue';
import TextPromo from '~/components/blocks/TextPromo.vue';
import WysiwygBlock from '~/components/blocks/WysiwygBlock.vue';

export default {
  'accordion_block': AccordionBlock,
  'article_listings_block': ArticleListing,
  'article_products': ArticleProducts,
  'category_listing_block': CategoryListing,
  'complaint_block': ComplaintForm,
  'contact_block': ContactForm,
  'cover_block': CoverBlock,
  'dynamic_promo_grid_block': DynamicPromoGrid,
  'editorial_product_block': EditorialProduct,
  'full_width_bannergallery_block': ImageGallery,
  'number_list_block': NumberList,
  'product_listing_block': ProductListingBlock,
  'promo_grid_block': PromoGrid,
  'quote_block': QuoteBlock,
  'statistics_block': StatisticsBlock,
  'text_promo_block': TextPromo,
  'video_block': TextImageVideoBlock,
  'wysiwyg': WysiwygBlock,
};
